var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.clickHandler}},[_c(_vm.component,{tag:"component",staticClass:"custom",attrs:{"data":_vm.data,"row":_vm.row}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }